(() => {
  const update = () => {
    const selected = document.querySelector('.ba-chosen');
    let currency = selected ? selected.textContent.trim().toUpperCase() : '';
    if (!currency) {
      try { currency = JSON.parse(sessionStorage.getItem('bacurr_user_cur')) || ''; } catch {}
    }
    if (!currency) currency = window.Shopify?.currency?.active || 'ZAR';
    const visible = currency === 'EUR' || currency === 'USD';
    const template = document.getElementById('Lamu-Currency-Selector-Note');
    if (template) {
      document.querySelectorAll('.baDropdownStyle').forEach(selector => {
        if (!selector.querySelector('.lamu-currency-selector-note')) selector.append(template.content.cloneNode(true));
      });
    }
    document.querySelectorAll('[data-lamu-currency-notice]').forEach(notice => {
      if (notice.hidden === visible) notice.hidden = !visible;
      if (!visible && notice.tagName === 'DETAILS') notice.open = false;
    });
    document.querySelectorAll('[data-lamu-currency-label]').forEach(label => {
      const text = currency === 'USD' ? label.dataset.usd : label.dataset.eur;
      if (label.textContent !== text) label.textContent = text;
    });
    const full = document.querySelector('[data-lamu-currency-full], .lamu-currency-explanation');
    if (full && visible) {
      document.querySelectorAll('.bacurrcheckoutNotice').forEach(notice => {
        if (notice.textContent !== full.textContent) notice.textContent = full.textContent;
      });
    }
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  };
  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('storage', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
